import {
  CHECK_RESULTS,
  type CheckResult,
  type SnapshotDto,
} from '@internal/scorecards-common';

import type { ChipColor } from '../StatusBadge/StatusBadge';

// 'no-run' only exists in the UI: a check with no snapshot yet for this entity.
const NO_RUN = 'no-run';
// 'unknown' only exists in the UI: a snapshot whose result the UI doesn't
// recognise (bad data, or a value added on the backend first). It renders as
// a neutral badge instead of crashing the tab, and isn't offered as a filter.
const UNKNOWN = 'unknown';

export type CheckResultDisplay = CheckResult | typeof NO_RUN | typeof UNKNOWN;

// sortOrder drives the ascending status sort: no snapshot first, passed last.
export const CHECK_RESULT_DISPLAY: Record<
  CheckResultDisplay,
  { tone: ChipColor; label: string; sortOrder: number }
> = {
  [NO_RUN]: { tone: 'neutral', label: 'No run', sortOrder: 0 },
  [UNKNOWN]: { tone: 'neutral', label: 'Unknown', sortOrder: 1 },
  failed: { tone: 'danger', label: 'Failed', sortOrder: 2 },
  passed: { tone: 'success', label: 'Passed', sortOrder: 3 },
};

// Values a user can filter by: every real result plus "no snapshot yet".
export const FILTERABLE_CHECK_RESULTS: readonly CheckResultDisplay[] = [
  ...CHECK_RESULTS,
  NO_RUN,
];

const isCheckResult = (value: unknown): value is CheckResult =>
  (CHECK_RESULTS as readonly unknown[]).includes(value);

export const toCheckResultDisplay = (
  snapshot: SnapshotDto | null,
): CheckResultDisplay => {
  if (!snapshot) return NO_RUN;
  return isCheckResult(snapshot.result) ? snapshot.result : UNKNOWN;
};
